import { GET_DEALINQUIRIES, DEALINQUIRY_LOADING } from "../actions/types";

const initialState = {
  dealInquiries: null,
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DEALINQUIRY_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_DEALINQUIRIES:
      return {
        ...state,
        dealInquiries: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
